var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){$event.preventDefault();return _vm.unsaveItemFxn(_vm.itemId)}}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Unsave Item ")])}
var staticRenderFns = []

export { render, staticRenderFns }